import { useRef, useEffect, useCallback, useState } from "react";
import useMediaQuery from "../Hooks/useMediaQuery";
let timeoutId;

export function Video(props) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const { deviceScreen } = useMediaQuery();
  const isMobilePhone = ["x-small"].includes(deviceScreen);
  const { url="", videoType="video/mp4", sources=[], className="", muted=false, playsInline="playsInline", preload="metadata", notSupportText=null, ...videoAttrs } = props;
  const videoSources = [{
    url,
    videoType
  }]
  .concat([...sources.filter((source) => source.url !== url)])
  .filter(source => source.url && source.videoType);

  useEffect(() => {
    videoRef.current?.load();
  }, [url]);

  const playToggle = useCallback((toggleValue) => {
    if (toggleValue === true) {
      videoRef.current?.play();
      setIsPlaying(true);
    } else {
      videoRef.current?.pause();
      setIsPlaying(false);
    }
  }, [videoRef]);

  const videoStyles = {
    width: "100%"
  };

  const buttonStyles = isMobilePhone ? {
    padding: "0",
    width: "50px",
    background: "transparent",
    border: "none",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginLeft: "-25px",
    transform: "translate(0, -50%)",
    display: isPlaying ? "none" : "inline",
  } : {
    padding: "0",
    width: "15%",
    background: "transparent",
    border: "none",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginLeft: "-7.5%",
    transform: "translate(0, -50%)",
    display: isPlaying ? "none" : "inline"
  };

  const controls = isPlaying ? "controls" : null;

  const playVideo = useCallback(() => {
    clearTimeout(timeoutId);
    if(videoRef?.current?.play) {
      playToggle(true);
    }
  }, [videoRef, playToggle, timeoutId]);

  const pauseVideo = useCallback(() => {
    /*******************************************************************************************
      Why the timeout?
      To prevent immediately hiding the controls when clicking on the video progress bar.
    ********************************************************************************************/
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      if(videoRef?.current?.pause) {
        playToggle(false);
      }
    }, 100);
  }, [videoRef, playToggle, timeoutId]);

  useEffect(() => {
    let videoElement = videoRef.current;

    if (videoElement) {
      videoElement.addEventListener("play", playVideo);
      videoElement.addEventListener("pause", pauseVideo);
    }

    return () => {
      if (videoElement?.removeListener) {
        videoElement.removeListener("play", playVideo);
        videoElement.removeListener("pause", pauseVideo);
      }
    };
  }, [videoRef]);

  if (!videoSources.length) {
    return null;
  }

  return (
    <div className="video-player" style={{position: "relative"}}>
      <video ref={videoRef} className={`${className}`} style={videoStyles} playsInline={playsInline} muted={muted} controls={controls} preload={preload} {...videoAttrs}>
        {videoSources.map(({url, videoType}) => <source key={url} src={`${url}#t=0.001`} type={videoType} />)}
        {notSupportText}
      </video>
      <button style={buttonStyles} onClick={() => playToggle(true)}><img src="https://wvusstatic.com/wvus_assets/images/icon_play.svg" alt="play icon" style={{width: "100%"}} /></button>
    </div>
  );
}

export default Video;